<template>
    <section class="h-full">
        <div class="pda-default t-center">
            <!-- <div class="mgt-26 t-center">
                <img :src="brandLogo" class="login-logo">
            </div> -->

            <div class="mgt-29 t-center t-headline4">
                {{$t('1526')}}
                <!-- 이미 가입된 계정 -->
            </div>
            <div class="mgt-25 t-center t-body3 t-color-content1">
                {{$t('1527')}}<br>
                {{$t('1528')}}
            </div>
            <div class="mgt-50 align-center">
                <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="$moveLogin()">
                    {{$t('1529')}}
                    <!-- 로그인하기 -->
                </button>
            </div>
        </div>
    </section>
    
</template>

<script>
/**
 * 회원가입 - 소셜 계정 존재 컴포넌트(sign up - exist social account component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
    data() {
        return {
            brandLogo: localStorage.brandLogo,
        }
    },
    
}
</script>